import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import DashboardService from '../../services/dashboard.service'
import { getRoleAccessKeySelector } from '../../store/selectors/app.selector'
import './navbar.css'
import Side_DashboardIcon from 'custom/assets/side-bar/Dashboard_Sidebar.svg'
import { SIDE_NAV_KEYS } from '../../utils/translation-constants'

export default function Navigation() {
  const roleAccessKey = useSelector(getRoleAccessKeySelector)
  const [userRoleList, setUserRoleList] = useState([])
  const { t } = useTranslation()

  useEffect(() => {
    getMenuOptions()
    return () => {}
  }, [roleAccessKey])

  const getMenuOptions = useCallback(async () => {
    try {
      const response = await DashboardService.getMenuDetails(roleAccessKey)
      if (response.status === 200) {
        setUserRoleList(response.data)
      }
    } catch (err) {
      console.error(err)
    }
  }, [roleAccessKey])

  return (
    <div className='side-bar-section'>
      <NavLink
        className='nav-card '
        key={0}
        activeClassName='nav-card-selected'
        to={'/dashboard'}>
        <img src={Side_DashboardIcon} />
      </NavLink>
      {userRoleList.map((option, index) => (
        <NavLink
          activeClassName='nav-card-selected'
          key={index}
          to={option.link}
          className='nav-card '>
          <img className='sidebar_menu_img' src={t(option.icon)} />
        </NavLink>
      ))}

      <div className='detailed-view'>
      <NavLink
        className='nav-card '
        key={0}
        activeClassName='nav-card-selected'
        to={'/dashboard'}>
        <img src={Side_DashboardIcon} />
        <span>{t(SIDE_NAV_KEYS.DASHBOARD)}</span>
        </NavLink>
        {userRoleList.map((option, index) => (
          <NavLink
            activeClassName='nav-card-selected'
            key={index}
            to={option.link}
            className='nav-card '>
            <img className='sidebar_menu_img' src={option.icon} />
            <span>{t(option.title)}</span>
          </NavLink>
        ))}
      </div>
    </div>
  )
}
